import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {Auth} from '../../models/authModel';
import {AuthGuardProps} from './types';

interface WithInjectedProps extends AuthGuardProps {
  auth: Auth;
}

@inject('auth')
@observer
export default class AuthGuard extends React.Component<AuthGuardProps, {}> {
  public render() {
    const {
      auth: {isLoggedIn},
      authorizedComponent,
      unauthorizedComponent,
      ...restProps
    } = this._withInjectedProps;

    return isLoggedIn
      ? this._renderComponent(authorizedComponent, restProps)
      : this._renderComponent(unauthorizedComponent, restProps);
  }

  private _renderComponent(component: React.ReactNode | React.ComponentType, props: {}) {
    const Component = component as React.ComponentType;

    return React.isValidElement(component) ? React.cloneElement(component, props) : <Component {...props} />;
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/components/AuthGuard/AuthGuard.tsx